cb.define([], function () { //编辑 新增 商品模板
  var PC_pc_managementclass_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
       debugger
		let valModel = viewmodel.get('productClass_Name');
		 valModel && valModel.on('beforeValueChange', ({value}) => {
			
			if (value) {
				if (!value.isEnd) {
					cb.utils.alert('请选择末级节点', 'warning');
					return value.isEnd
				}
			}
		})
   
    }
  }
  try {
    module.exports = PC_pc_managementclass_VM_Extend;
  } catch (error) {
 
  }
  return PC_pc_managementclass_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_managementclass_VM.Extend.js